import React from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'
import DescriptionIcon from 'components/material-symbol/icons/Description'
import FileDownloadIcon from 'components/material-symbol/icons/FileDownload'
import useIconAccessor from 'components/lesson-type-category/icons'
import BookingAttachmentCard from 'components/stream-messaging/components/booking-attachment-card'
import CampaignMessageLabel from 'components/stream-messaging/campaign-message-label'
import { messagingRenderText } from 'components/stream-messaging/messaging-render-text'
import useStyles from './styles'

// Real cards only render their call to action with a link; the preview links
// are inert.
const PREVIEW_URL = 'https://my.pga.com'

export default function ChatPreview({ body, offerings, media }) {
  const classes = useStyles()
  const iconAccessor = useIconAccessor()
  const images = media.filter(item => item.kind === 'IMAGE')
  const files = media.filter(item => item.kind !== 'IMAGE')
  const hasAttachments = offerings.length + media.length > 0

  return (
    <Box className={classes.chatPreview} data-testid="campaign-chat-preview">
      <CampaignMessageLabel />
      <Box
        className={clsx(
          classes.chatBubble,
          hasAttachments && classes.chatBubbleWithAttachments,
        )}
      >
        {images.map(item => (
          <img
            key={item.url}
            src={item.url}
            alt={item.title || 'Campaign image'}
            className={classes.chatImage}
          />
        ))}
        {offerings.map(offering => {
          const isGroupEvent = offering.offeringType === 'GROUP_EVENT'
          return (
            <BookingAttachmentCard
              key={`${offering.offeringType}-${offering.id}`}
              bookingUrl={PREVIEW_URL}
              title={offering.title}
              type={isGroupEvent ? 'pga_group_event' : 'pga_lesson_type'}
              fallbackIcon={
                (isGroupEvent ? iconAccessor.GROUP : iconAccessor.PRIVATE).icon
              }
            />
          )
        })}
        {files.map(item => (
          <Box key={item.url} className={classes.chatFile}>
            <span className={classes.chatFileIcon}>
              <DescriptionIcon fontSize="small" />
            </span>
            <Typography className={classes.chatFileName}>
              {item.title || 'Attachment'}
            </Typography>
            <FileDownloadIcon htmlColor="#172024" />
          </Box>
        ))}
        {body ? (
          <Typography component="div" className={classes.chatText}>
            {messagingRenderText(body, [])}
          </Typography>
        ) : null}
      </Box>
    </Box>
  )
}

ChatPreview.propTypes = {
  body: PropTypes.string,
  offerings: PropTypes.arrayOf(
    PropTypes.shape({
      offeringType: PropTypes.oneOf(['LESSON_TYPE', 'GROUP_EVENT']).isRequired,
      id: PropTypes.string.isRequired,
      title: PropTypes.string,
    }),
  ).isRequired,
  media: PropTypes.arrayOf(
    PropTypes.shape({
      kind: PropTypes.oneOf(['IMAGE', 'FILE']).isRequired,
      url: PropTypes.string.isRequired,
      title: PropTypes.string,
    }),
  ).isRequired,
}
